/* Lafine · Navy Blush — reveal, parallax, Lisa launcher, scroll-scrubbed frame sequence, dock */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.nb-reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Parallax: data-nb-parallax="0.15" (fraction of scroll offset, negative = opposite) */
  function initParallax() {
    if (reduce) return;
    var items = [].slice.call(document.querySelectorAll('[data-nb-parallax]'));
    if (!items.length) return;
    var ticking = false;
    function frame() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var center = r.top + r.height / 2 - vh / 2;
        el.style.transform = 'translate3d(0,' + (center * parseFloat(el.dataset.nbParallax)).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    window.addEventListener('resize', frame);
    frame();
  }

  /* Lisa Preview & Mode Manager (?lisa=on / ?lisa=off / settings.enable_lisa_ai) */
  function isLisaActive() {
    var cfg = window.LAFINE_LISA_CONFIG || {};
    try {
      var params = new URLSearchParams(window.location.search);
      var q = params.get('lisa');
      if (q === 'on' || q === '1' || q === 'true') {
        localStorage.setItem('lafine_lisa_preview', 'on');
      } else if (q === 'off' || q === '0' || q === 'false') {
        localStorage.removeItem('lafine_lisa_preview');
      }
      return Boolean(cfg.globalEnabled || localStorage.getItem('lafine_lisa_preview') === 'on');
    } catch (err) {
      return Boolean(cfg.globalEnabled);
    }
  }

  function showLisaPreviewBadge() {
    if (document.getElementById('nb-lisa-badge')) return;
    var b = document.createElement('div');
    b.id = 'nb-lisa-badge';
    b.innerHTML = '<span>Lisa AI: <b>Preview Mode</b></span><a href="?lisa=off" title="Exit Preview">✕ Exit</a>';
    document.body.appendChild(b);
  }

  function initLisaMode() {
    var cfg = window.LAFINE_LISA_CONFIG || {};
    var active = isLisaActive();

    if (active) {
      document.documentElement.classList.add('lisa-active');

      var isPreview = false;
      try {
        isPreview = localStorage.getItem('lafine_lisa_preview') === 'on';
      } catch (e) {}

      if (isPreview && !cfg.globalEnabled) {
        showLisaPreviewBadge();
      }

      // Inject chat widget script if not present
      if (!document.getElementById('beai-widget-script')) {
        var s = document.createElement('script');
        s.id = 'beai-widget-script';
        s.src = 'https://widget.beai.expert/widget.js';
        s.setAttribute('data-site-key', cfg.siteKey || 'pk_live_lafinecakes8a7f1c3e');
        s.setAttribute('data-api-base', cfg.apiBase || 'https://prospect-incubator-api-331932342116.us-west1.run.app');
        s.defer = true;
        document.body.appendChild(s);
      }
    } else {
      document.documentElement.classList.remove('lisa-active');
      var badge = document.getElementById('nb-lisa-badge');
      if (badge) badge.remove();
    }
  }

  /* Lisa launcher: [data-lisa-prompt="..."] opens widget if active, or routes directly to WhatsApp */
  function openLisa(prompt) {
    if (!isLisaActive()) {
      window.open('https://wa.me/61424667112?text=' + encodeURIComponent(prompt), '_blank', 'noopener');
      return;
    }
    if (window.BEAIChat && window.BEAIChat.open) { window.BEAIChat.open('text', prompt); return; }
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (window.BEAIChat) { clearInterval(t); window.BEAIChat.open('text', prompt); }
      else if (tries > 25) { clearInterval(t); window.open('https://wa.me/61424667112?text=' + encodeURIComponent(prompt), '_blank', 'noopener'); }
    }, 150);
  }
  function initLisa() {
    initLisaMode();
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lisa-prompt]');
      if (!b) return;
      e.preventDefault();
      openLisa(b.getAttribute('data-lisa-prompt') || 'Hi Lafine! I would like to enquire about your cakes and catering.');
    });
  }

  /* Scroll-scrubbed frame sequence on canvas (with responsive mobile portrait & desktop landscape sequences) */
  function initSequence() {
    document.querySelectorAll('[data-nb-seq]').forEach(function (root) {
      var canvas = root.querySelector('canvas');
      var desktopUrls = JSON.parse(root.getAttribute('data-frames') || '[]');
      var mobileUrls = JSON.parse(root.getAttribute('data-frames-mobile') || '[]');
      var steps = [].slice.call(root.querySelectorAll('.nb-seq__step'));
      var bar = root.querySelector('.nb-seq__bar i');
      var fallback = root.querySelector('.nb-seq__fallback');
      if (!canvas) return;

      var currentUrls = [];
      var imgs = [];
      var cur = -1;
      var isMobileActive = null;

      function getActiveUrls() {
        var isMobile = window.innerWidth < 768;
        if (isMobile && mobileUrls && mobileUrls.length) return { urls: mobileUrls, isMobile: true };
        return { urls: desktopUrls && desktopUrls.length ? desktopUrls : mobileUrls, isMobile: false };
      }

      function loadSequence() {
        var active = getActiveUrls();
        if (isMobileActive === active.isMobile && currentUrls.length) return;
        isMobileActive = active.isMobile;
        currentUrls = active.urls;
        if (!currentUrls.length) return;

        imgs = new Array(currentUrls.length);
        cur = -1;
        currentUrls.forEach(function (u, i) {
          var im = new Image(); im.decoding = 'async';
          im.onload = function () {
            if (i === 0) {
              if (fallback) fallback.style.display = 'none';
              size();
            }
          };
          im.src = u;
          imgs[i] = im;
        });
      }

      var ctx = canvas.getContext('2d');
      function size() {
        var d = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = canvas.clientWidth * d;
        canvas.height = canvas.clientHeight * d;
        draw(cur < 0 ? 0 : cur, true);
      }
      function draw(i, force) {
        if (!imgs.length) return;
        var img = imgs[i];
        if (!img || !img.complete || (i === cur && !force)) return;
        cur = i;
        var cw = canvas.width, ch = canvas.height, s = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
        var w = img.naturalWidth * s, h = img.naturalHeight * s;
        ctx.drawImage(img, (cw - w) / 2, (ch - h) / 2, w, h);
      }

      loadSequence();

      var targetProgress = 0, currentProgress = 0, animId = null;
      function renderLoop() {
        currentProgress += (targetProgress - currentProgress) * 0.1;
        var p = Math.min(1, Math.max(0, currentProgress));
        if (currentUrls.length) {
          draw(Math.min(currentUrls.length - 1, Math.round(p * (currentUrls.length - 1))));
        }
        if (bar) bar.style.width = (p * 100) + '%';
        var idx = Math.min(steps.length - 1, Math.floor(p * steps.length));
        steps.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
        if (Math.abs(targetProgress - currentProgress) > 0.0005) {
          animId = requestAnimationFrame(renderLoop);
        } else {
          animId = null;
        }
      }
      function onScroll() {
        var r = root.getBoundingClientRect(), total = r.height - window.innerHeight;
        if (total <= 0) return;
        targetProgress = Math.min(1, Math.max(0, -r.top / total));
        if (!animId) animId = requestAnimationFrame(renderLoop);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () {
        loadSequence();
        size();
      });
      size();
      onScroll();
    });
  }

  /* Mobile dock appears after first screen */
  function initDock() {
    var dock = document.querySelector('.nb-dock'); if (!dock) return;
    function chk() { dock.classList.toggle('is-on', window.scrollY > window.innerHeight * 0.5); }
    window.addEventListener('scroll', chk, { passive: true }); chk();
  }

  /* BeTag star rating */
  function initStars() {
    document.querySelectorAll('.nb-betag__stars').forEach(function (box) {
      var btns = [].slice.call(box.querySelectorAll('button'));
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () {
          btns.forEach(function (x, k) { x.classList.toggle('is-on', k <= i); });
          var msg = i >= 3 ? box.dataset.good : box.dataset.bad;
          var out = document.getElementById(box.dataset.target);
          if (out) { out.hidden = false; out.querySelector('[data-lisa-prompt]').setAttribute('data-lisa-prompt', msg + ' (rating: ' + (i + 1) + '/5)'); }
        });
      });
    });
  }

  /* Google Reviews on-site modal dialog and filter tabs */
  function initReviewsModal() {
    var openBtn = document.getElementById('openReviewsModal');
    var overlay = document.getElementById('reviewsModalOverlay');
    var closeBtn = document.getElementById('closeReviewsModal');
    var backdrop = document.getElementById('reviewsModalBackdrop');
    if (!overlay) return;

    function openModal() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', openModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (backdrop) backdrop.addEventListener('click', closeModal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
        closeModal();
      }
    });

    // Filter tabs inside the reviews modal
    var filterPills = overlay.querySelectorAll('.nb-filter-pill');
    var reviewCards = overlay.querySelectorAll('.nb-modal-review-card');
    filterPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var cat = pill.getAttribute('data-filter');
        filterPills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');

        reviewCards.forEach(function (card) {
          var cardCat = card.getAttribute('data-category');
          if (cat === 'all' || cardCat === cat) {
            card.style.display = 'block';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  function boot() {
    initReveal();
    initParallax();
    initLisa();
    initSequence();
    initDock();
    initStars();
    initReviewsModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify Theme Editor live reload support:
  // When an admin edits a section or setting, Shopify replaces DOM nodes and fires these events.
  document.addEventListener('shopify:section:load', function () {
    boot();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target) {
      e.target.querySelectorAll('.nb-reveal').forEach(function (el) { el.classList.add('is-in'); });
    }
  });
  document.addEventListener('shopify:section:reorder', function () {
    boot();
  });
})();

